<template>
  <div class="animated fadeIn" v-permission="'VIEW_PORTFOLIO'">
    <portfolio-widget-row :fetch="true" />
    <div id="vulnerabilitiesToolbar" class="bs-table-custom-toolbar">
      <b-button size="md" variant="outline-primary" v-b-modal.vulnerabilityCreateVulnerabilityModal v-permission="PERMISSIONS.VULNERABILITY_MANAGEMENT">
        <span class="fa fa-plus"></span> {{ $t('message.create_vulnerability') }}
      </b-button>
    </div>
    <bootstrap-table
      ref="table"
      :columns="columns"
      :data="data"
      :options="options">
    </bootstrap-table>
    <vulnerability-create-vulnerability-modal v-on:refreshTable="refreshTable"/>
  </div>
</template>

<script>
  import common from "../../../shared/common";
  import PortfolioWidgetRow from "../../dashboard/PortfolioWidgetRow";
  import VulnerabilityCreateVulnerabilityModal from "./VulnerabilityCreateVulnerabilityModal";
  import xssFilters from "xss-filters";
  import permissionsMixin from "../../../mixins/permissionsMixin";
  import $ from "jquery";

  export default {
    mixins: [permissionsMixin],
    components: {
      VulnerabilityCreateVulnerabilityModal,
      PortfolioWidgetRow
    },
    methods: {
      apiUrl: function () {
        return `${this.$api.BASE_URL}/${this.$api.URL_VULNERABILITY}`;
      },
      refreshTable: function() {
        this.$refs.table.refresh({
          url: this.apiUrl(),
          silent: true
        });
      },
      initializeTooltips: function () {
        $('[data-toggle="tooltip"]').tooltip();
      },
    },
    data() {
      return {
        columns: [
          {
            title: this.$t('message.name'),
            field: "vulnId",
            sortable: true,
            formatter(value, row, index) {
              let url = xssFilters.uriInUnQuotedAttr("../vulnerabilities/" + row.source + "/" + value);
              return common.formatSourceLabel(row.source) + ` <a href="${url}">${xssFilters.inHTMLData(value)}</a>`;
            }
          },
          {
            title: this.$t('message.published'),
            field: "published",
            sortable: true,
            formatter(value, row, index) {
              if (typeof value !== 'undefined') {
                return common.formatTimestamp(value);
              }
            }
          },
          {
            title: this.$t('message.cwe'),
            field: "cwes",
            sortable: false,
            formatter(value, row, index) {
              if (typeof value !== 'undefined') {
                let s = '';
                for(let i = 0; i < value.length; i++) {
                  let cwe = value[i];
                  if (i > 0) {
                    s += ',&nbsp;&nbsp;&nbsp;'
                  }
                  s += `CWE-${cwe.cweId}`
                }
                return s;
              }
            }
          },
          {
            title: this.$t('message.projects'),
            field: "affectedProjectCount",
            class: "tight",
            sortable: false
          },
          {
            title: this.$t('message.severity'),
            field: "severity",
            sortable: false,
            formatter(value, row, index) {
              if (typeof value !== 'undefined') {
                return common.formatSeverityLabel(value);
              }
            }
          }
        ],
        data: [],
        options: {
          onPostBody: this.initializeTooltips,
          search: true,
          showColumns: true,
          showRefresh: true,
          pagination: true,
          silentSort: false,
          sidePagination: 'server',
          queryParamsType: 'pageSize',
          pageList: '[10, 25, 50, 100]',
          pageSize: 10,
          icons: {
            refresh: 'fa-refresh'
          },
          toolbar: '#vulnerabilitiesToolbar',
          responseHandler: function (res, xhr) {
            res.total = xhr.getResponseHeader("X-Total-Count");
            return res;
          },
          url: this.apiUrl()
        }
      };
    }
  };
</script>
